<div class="sondermind-toast {{ cssClass().color }}"
    [@.disabled]="!isDismissable"
    [@fadeAnimation]="{value: animationState, params: { fadeIn: 260, fadeOut: 400 }}"
    (@fadeAnimation.done)="onFadeFinished($event)">
    <div>
        <mat-icon *ngIf="cssClass().iconType && showIcon">{{ cssClass().iconType }}</mat-icon>
        <span
          data-test="change-therapist-green-banner"
          [innerHTML]="message"
          *ngIf="message; else ngContent"
        >
        </span>
        <ng-template #ngContent>
          <span data-test="change-therapist-green-banner">
            <ng-content></ng-content>
          </span>
        </ng-template>
    </div>
    <mat-icon *ngIf="isDismissable" (click)="dismissToast()">close</mat-icon>
</div>
